export const DEFAULT_CHANCE = 50;

const RED = [255, 59, 48] as const;
const GREEN = [52, 199, 89] as const;

export function normalizeChance(value: unknown): number {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return DEFAULT_CHANCE;
  return Math.min(100, Math.max(0, Math.round(numeric)));
}

export function chanceColor(value: unknown): string {
  const ratio = normalizeChance(value) / 100;
  const channels = RED.map((channel, index) => Math.round(channel * (1 - ratio) + GREEN[index]! * ratio));
  return `rgb(${channels.join(', ')})`;
}
